//============ pengesoft.workzonedata.User =============
import {
  DataPacket
} from '@/base/DataPacket';


export class User extends DataPacket {
  constructor(opts= {}){
      super();
      this.UserParam = opts.UserParam?new UserExParameter(opts.UserParam):new UserExParameter();
      this.LoginId = opts.LoginId || '';
      this.Description = opts.Description || '';
      this.FullName = opts.FullName || '';
      this.Type = opts.Type || null;
      this.Password = opts.Password || '';
      this.Parameter = opts.Parameter || '';
      this.SecLevel = opts.SecLevel || null;
      this.Limits =opts.Limits? new LimitsRec(opts.Limits) : new LimitsRec();
      this.Status = opts.Status || null;
  }
}


//============ pengesoft.workzonedata.UserExParameter =============

export class UserExParameter extends DataPacket {
  constructor(opts= {}){
      super();
      this.AppraisalPriceForBankCodes = opts.AppraisalPriceForBankCodes || '';
      this.UserSigns = opts.UserSigns || '';
      this.OpenID = opts.OpenID || '';
      this.CantonCode = opts.CantonCode || '';
      this.OrgCode = opts.OrgCode || '';
      this.MiniProgramOpenID = opts.MiniProgramOpenID || '';
      this.BisTypes = opts.BisTypes || '';
      this.UserType = opts.UserType || '';
      this.Remark1 = opts.Remark1 || '';
      this.Remark3 = opts.Remark3 || '';
      this.Remark2 = opts.Remark2 || '';
  }
}


//============ pengesoft.workzonedata.LimitsRec =============

export class LimitsRec extends DataPacket {
  constructor(opts= {}){
      super();
      this.DateTime = opts.DateTime || null;
      this.UserDef = opts.UserDef || '';
      this.IP = opts.IP || [];
      this.CPU = opts.CPU || '';
      this.SN = opts.SN || '';
      this.HddSN = opts.HddSN || '';
      this.IPRange = opts.IPRange || [];
      this.Mac = opts.Mac || '';
  }
}

